
import React from 'react';

interface InstanceStatusIndicatorProps {
  status: string;
}

const InstanceStatusIndicator: React.FC<InstanceStatusIndicatorProps> = ({ status }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active': return 'bg-green-500';
      case 'suspended': return 'bg-amber-500';
      case 'inactive': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  return (
    <div className="flex items-center">
      <div className={`h-2.5 w-2.5 rounded-full ${getStatusColor(status)} mr-2`}></div>
      <span className="capitalize">{status}</span>
    </div>
  );
};

export default InstanceStatusIndicator;
